module.exports = __webpack_public_path__ + "static/hero1-1ae36f5a1035e7423ef8d5d21b8a6550.jpg";